import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./app/component/selfCheckin/HomePage";
import Registration from "./app/component/selfCheckin/Registration";
import Preview from "./app/component/selfCheckin/Preview";
import Registration1 from "./app/component/selfCheckin/Registration1";
import ThankYou from "./app/component/selfCheckin/ThankYou";
import Signature from "./app/component/selfCheckin/Signature";
import HomeInfo from "./app/component/selfCheckin/HomeInfo";
import PreviewExample from "./app/component/selfCheckin/PreviewExample";
import Unauthorised from "./app/component/selfCheckin/Unauthorised";
import CheckedIn from "./app/component/selfCheckin/CheckedIn";
import NotFoundPage from "./app/component/selfCheckin/NotFoundPage";
import { Provider } from "react-redux";
import { store } from "./app/store/store";
import UserLinkUrl from "./app/component/selfCheckin/UserLinkUrl";

function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <Routes>
          <Route>
            <Route exact path="/" element={<UserLinkUrl/>}/>
            <Route path="/HomePage/:id" element={<HomePage />} />
            <Route path="Registration" element={<Registration />} />
            <Route path="Registration1" element={<Registration1 />} />
            <Route path="HomeInfo" element={<HomeInfo />} />
            <Route path="ThankYou" element={<ThankYou />} />
            <Route path="Preview" element={<Preview />} />
            <Route path="PreviewExample" element={<PreviewExample />} />
            <Route path="Signature" element={<Signature />} />
            <Route path="Unauthorised" element={<Unauthorised />} />
            <Route path="auth/:id" element={<NotFoundPage />} />
            <Route path="restrict" element={<CheckedIn />} />
          </Route>
        </Routes>
      </Provider>
    </BrowserRouter>
  );
}

export default App;



